// extracted by mini-css-extract-plugin
export default {"avatar":"MessageAvatar_avatar__dg5OH"};